/**
 * Legacy InstantCache full dumps — never hydrate into the JS heap.
 * Customer packs can hold ~400MB+ per key and OOM the renderer on boot.
 */
export function isLegacyDiscardKvKey(key) {
  if (!key || typeof key !== 'string') return false;
  return key === 'instantCache_persistent' || key.startsWith('instantCache_persistent_');
}
